module.exports = __webpack_public_path__ + "static/img/login_user.72e66ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_user.png
// module id = jcF9
// module chunks = 1